import React from 'react';
import Select from 'react-select';
import * as Const from '../../utils/Const';
import { autocompleteClasses } from '@mui/material';

interface DropdownMultiProps {
  label: string;
  data: { id: number; name: string }[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

const DropdownMulti: React.FC<DropdownMultiProps> = ({ label, data, selected, onChange }) => {
  // react-select用のデータ形式に変換
  const options = data.map((item) => ({ value: item.name, label: item.name }));

  // 選択された値をreact-select形式に変換
  const selectedOptions = options.filter((option) => selected.includes(option.value));

  return (
    <label className="flex items-center">
      <span className="text-base font-bold">{label}：</span>
      <Select
        options={options} // 選択肢
        value={selectedOptions} // 選択された値
        onChange={(selectedOptions) => {
          // 選択された値を配列で更新
          const values = selectedOptions ? selectedOptions.map((option) => option.label) : [];
          onChange(values);
        }}
        isMulti={true}
        className={`basic-multi-select`}
        placeholder={`${label}${Const.LabelDropdownMessage}`}
        styles={{
          control: (base) => ({
            ...base,
            width: '400px',
            maxHeight: '60px',
            borderWidth: '1px',
            borderColor: `${Const.SearchItemBorderColor}`,
            backgroundColor: `${Const.SearchItemColor}`,
          }),
          valueContainer: (base) => ({
            ...base,
            maxHeight: '40px',
            overflowY: 'auto',
            flexWrap: 'wrap',
          }),
        }}
      />
    </label>
  );
};

export { DropdownMulti };
